import React from 'react'
import { Helmet } from 'react-helmet'
import { Redirect } from 'react-router'
import classNames from 'classnames'
import { get404Url } from 'mobile_web/modules/navigation/routes'

import { IonGrid, IonRow, IonText, IonCol, IonFooter } from '@ionic/react'

import classnames from 'classnames'

import { Collection, CollectionTourContainer as Container } from 'mytours-read-common'
import { GetAppShowResponse, GetCollectionItemsIndexResponseData, GetCollectionsShowResponse, RedeemCode } from 'mytours-read-api-typescript'

import { CollectionListNavigationProps } from '../types'

import { getStyleProperty, getDirMode, format } from '../../platform'
import Page from '../../common/components/Page'
import { getImageAlt, getPageContainer, loadingTimeout } from '../../common/functions'
import Button from '../../common/components/Button'
import Modal from '../../common/components/modal'
import { ImageSizePreset } from '../../../common_lib/types'
import { generateImageSrcSet, generateImageUrl, getScreenSize } from '../../../common_lib/utils'
import { ScreenSize, ScreenSizeBreakpoints } from 'common_lib/types'
import { formatCurrency, validateCollectionCode } from 'mobile_web/modules/lockapp/functions'
import ScrollbarListener from 'mobile_web/modules/common/components/scrollbar-listener'
import { fade } from 'common_lib/services/color'

import Header from 'mobile_web/modules/common/components/header'

import ImagePlaceholder from '../../common/components/placeholders/Image'
import TextPlaceholder from 'mobile_web/modules/common/components/placeholders/Text'

import strings from '../../../strings'

import './styles/tour.less'
import ErrorMessageHandler from 'mobile_web/modules/common/components/error-message-handler'
import { DEFAULT_APP_INFO, loadAppMetaDataFromDisk } from 'mobile_web/modules/settings/functions'
import SectionMediaAudioComponent from 'mobile_web/modules/screen/components/parts/SectionMediaAudio'
import AudioPlayerBarComponent from 'mobile_web/modules/audio/components/AudioPlayerBar'
import LockAppComponent from 'mobile_web/modules/lockapp/components/LockApp'

interface OwnProps {
	isInsideModal?: boolean
}

type Props = Container.Props & Container.Actions & CollectionListNavigationProps & OwnProps

interface State {
	imageWidth: number
	imageHeight: number
	screenSize: ScreenSize
	showLockModal: boolean
	codeLock: boolean
	hasWebPrice: boolean
	openPayModalImmediately: boolean
	loading: boolean
	distanceUnit: GetAppShowResponse.DistanceUnitEnum
}

class CollectionTour extends React.Component<Props, State> {
	itemVersion = 0
	collectionDetailsLoading = false
	tourLoading = false

	footerRef = React.createRef<HTMLIonFooterElement>()

	constructor(props: Props) {
		super(props)

		const screenSize = getScreenSize()

		this.state = {
			...this.getImageDimensions(screenSize),
			screenSize,
			showLockModal: false,
			codeLock: null,
			hasWebPrice: null,
			openPayModalImmediately: false,
			loading: this.props.loading,
			distanceUnit: null,
		}
	}

	componentDidUpdate(prevProps: Container.Props): void {
		const { language, collectionId, collectionVersion, accountId, hasLoadedStops, isLoadingStops, item, validateCode, loading } =
			this.props

		if (collectionVersion) {
			if (
				(!this.collectionDetailsLoading && language !== prevProps.language) ||
				collectionId !== prevProps.collectionId ||
				!item
			) {
				this.props.loadCollectionDetails(collectionVersion, language, accountId)
				this.collectionDetailsLoading = true
			}

			if (!this.tourLoading && ((!hasLoadedStops && !isLoadingStops) || collectionId !== prevProps.collectionId)) {
				this.props.downloadTour(collectionVersion, language, accountId)
				this.tourLoading = true
			} else if (item && item.version != this.itemVersion) {
				this.itemVersion = item.version
				this.props.downloadTour(collectionVersion, language, accountId)
			} else if (item) {
				this.tourLoading = false
				this.collectionDetailsLoading = false
			}
		}

		if (
			(this.state.codeLock === null && item?.hasOwnProperty('code_lock')) ||
			(this.state.hasWebPrice === null && item?.pricing?.web_price?.amount)
		) {
			const codeLock = item.code_lock
			const hasWebPrice = !!item.pricing?.active && !!item.pricing?.web_price?.amount
			this.setState({ codeLock, hasWebPrice }, async () => {
				if (codeLock || hasWebPrice) await validateCollectionCode(item, validateCode)

				if (hasWebPrice) {
					const url = new URL(window.location.href)
					const searchParams = url.searchParams
					const orderId = Number(searchParams.get('order-id'))
					// Open modal and check if the payment was successful
					if (orderId) {
						this.setState({ showLockModal: true })
					}			
				}
			})
		}

		if (prevProps.loading !== loading) {
			// loading with timeout to change skeleton with images content smoothly
			loadingTimeout(loading, val => this.setState({ loading: val }))
		}

		this.checkUnlockApp(prevProps)
	}

	componentDidMount(): void {
		const { collectionVersion, accountId, language, loadCollectionDetails } = this.props
		if (collectionVersion) {
			loadCollectionDetails(collectionVersion, language, accountId)
		}

		this.setDistanceUnit()

		addEventListener('resize', this.setImgDimension)
	}

	componentWillUnmount(): void {
		removeEventListener('resize', this.setImgDimension)
	}

	private setDistanceUnit = async (): Promise<void> => {
		const appData = await loadAppMetaDataFromDisk(DEFAULT_APP_INFO.projectId)

		this.setState({
			distanceUnit: appData?.distance_unit || null,
		})
	}

	getHeight = (width: number): number => width * 0.5625

	getImageDimensions = (screenSize: ScreenSize = getScreenSize()): Pick<State, 'imageHeight' | 'imageWidth'> => {
		let width = 0
		switch (screenSize) {
			case ScreenSize.lg:
			case ScreenSize.md: {
				width = ScreenSizeBreakpoints.lg
				break
			}
			case ScreenSize.sm: {
				width = ScreenSizeBreakpoints.md
				break
			}
			case ScreenSize.xs:
			default: {
				width = ScreenSizeBreakpoints.sm
				break
			}
		}
		return { imageHeight: this.getHeight(width), imageWidth: width }
	}

	private checkUnlockApp = (prevProps: Container.Props) => {
		const { lockCollection, item, validateCode } = this.props
		if (!lockCollection.loading && lockCollection.loaded) {
			if (lockCollection.status === 'valid' && !prevProps.lockCollection.status) {
				this.setState({ codeLock: false, hasWebPrice: false, showLockModal: false })
			} else if (
				(lockCollection.status === 'invalid' || lockCollection.status === 'expired') &&
				!prevProps.lockCollection.status
			) {
				validateCollectionCode(item, validateCode)
			}
		}
	}

	setImgDimension = (): void => {
		const { screenSize: prevScreenSize } = this.state
		const screenSize = getScreenSize()

		if (screenSize !== prevScreenSize) {
			this.setState({ ...this.getImageDimensions(screenSize), screenSize })
		}
	}

	onTourButtonPressed = (): void => {
		const { hasLoadedStops, isLoadingStops, item, collectionVersion, accountId, language } = this.props
		const { codeLock, hasWebPrice } = this.state

		if ((item?.code_lock && codeLock) || hasWebPrice) {
			this.setState({ showLockModal: true })
			return
		}

		if (collectionVersion) {
			// if tour is ready to start
			if (hasLoadedStops) {
				const tour = this.props.item
				const tourTitle = tour?.title || ''

				this.props.navigateToTourStop(collectionVersion, tourTitle, accountId)
				if (this.props.onBackAction) {
					this.props.onBackAction({ closeMapModal: true })
				}
			} else if (isLoadingStops) {
				// do nothing
			} else {
				// download tour
				this.props.downloadTour(collectionVersion, language, accountId)
			}
		}
	}

	onBuyButtonPressed = (): void => {
		this.setState({ showLockModal: true, openPayModalImmediately: true })
	}

	getTourDurationString = (): string => {
		const { item = {} as Collection } = this.props

		const minDurationString = format.duration(item.length_min) || ''
		const maxDurationString = format.duration(item.length_max) || ''

		return minDurationString && maxDurationString
			? `${minDurationString} - ${maxDurationString}`
			: minDurationString || maxDurationString || ''
	}

	getDistance = () => {
		const { item } = this.props
		const { distanceUnit } = this.state
		const distance = item?.distance

		if (!distance) {
			return null
		}

		return format.distance(distance, distanceUnit)
	}

	getTourTypeCustomIconName = (
		type: GetCollectionsShowResponse.TourTypeEnum,
		subtype: GetCollectionsShowResponse.TourSubtypeEnum,
	): string => {
		switch (type) {
			case GetCollectionsShowResponse.TourTypeEnum.Walking:
				return subtype ? `fa-ic-${subtype.replace(/\_/g, '-')}` : null
			case GetCollectionsShowResponse.TourTypeEnum.Cycling:
				return 'fa-ic-tour-type-bicycle'
			case GetCollectionsShowResponse.TourTypeEnum.Canoeing:
				return 'fa-ic-tour-type-canoe'
			case GetCollectionsShowResponse.TourTypeEnum.Driving:
				return 'fa-ic-tour-type-driving'
			case GetCollectionsShowResponse.TourTypeEnum._4wd:
				return 'fa-ic-tour-type-4wd'
			case GetCollectionsShowResponse.TourTypeEnum.HorseTrail:
				return 'fa-ic-tour-type-horse'
			case GetCollectionsShowResponse.TourTypeEnum.HistoricHouse:
				return 'fa-ic-tour-type-historic-house'
			case GetCollectionsShowResponse.TourTypeEnum.AboriginalSite:
				return 'fa-ic-tour-type-aboriginal'
			case GetCollectionsShowResponse.TourTypeEnum.Museum:
				return 'fa-ic-tour-type-museum'
			case GetCollectionsShowResponse.TourTypeEnum.Gallery:
				return 'fa-ic-tour-type-gallery'
			case GetCollectionsShowResponse.TourTypeEnum.Ship:
				return 'fa-ic-tour-type-ship'
			case GetCollectionsShowResponse.TourTypeEnum.Bus:
				return 'fa-ic-tour-type-bus'
			case GetCollectionsShowResponse.TourTypeEnum.Airplane:
				return 'fa-ic-tour-type-airplane'
			case GetCollectionsShowResponse.TourTypeEnum.Helicopter:
				return 'fa-ic-tour-type-helicopter'
			case GetCollectionsShowResponse.TourTypeEnum.NatureTrail:
				return 'fa-ic-tour-type-nature-trail'
			case GetCollectionsShowResponse.TourTypeEnum.Train:
				return 'fa-ic-tour-type-train'
		}

		return null
	}

	renderTourTypeIcon = () => {
		const { item = {} as Collection } = this.props

		const typeIconName = this.getTourTypeCustomIconName(item.tour_type, item.tour_subtype)

		if (typeIconName === null) {
			if (item.tour_type === GetCollectionsShowResponse.TourTypeEnum.Walking) {
				return (
					<>
						<i className="icon fas fa-walking" />
						<IonText className="label capitalize">{strings.tour_type_walking}</IonText>
					</>
				)
			}
			if (item.tour_type === GetCollectionsShowResponse.TourTypeEnum.ScavengerHunt) {
				return (
					<>
						<i className="icon fas fa-search" />
						<IonText className="label capitalize">{strings.tour_type_scavenger_hunt}</IonText>
					</>
				)
			}

			return undefined
		}

		return (
			<>
				<i className={classNames('icon', 'fak', typeIconName)} />
				{item?.tour_type && Object.values(GetCollectionsShowResponse.TourTypeEnum).includes(item.tour_type) ? (
					<IonText className="label capitalize">{strings[`tour_type_${item.tour_type}`]}</IonText>
				) : null}
			</>
		)
	}

	renderLockContentModal = () => {
		const { item } = this.props

		if (!item) {
			return undefined
		}

		const { code_title: codeTitle, code_text: codeText, code_background_media_item: codeBackgroundMediaItem } = item
		const { showLockModal, hasWebPrice, openPayModalImmediately } = this.state
		return (
			<Modal
				isOpen={showLockModal}
				cssClass="page-modal lock-page-modal"
				onDidDismiss={() => {
					this.setState({ openPayModalImmediately: false, showLockModal: false })
				}}
				showBackdrop={false}
			>
				<LockAppComponent
					linkedId={item.id}
					linkedType={RedeemCode.LinkedTypeEnum.Collection}
					title={codeTitle}
					description={codeText}
					backgroundImage={codeBackgroundMediaItem}
					webPrice={hasWebPrice && item.pricing.web_price}
					openPayModalImmediately={openPayModalImmediately}
				/>
			</Modal>
		)
	}

	renderTitle = (title: string): React.ReactNode => <h1 className="title">{title}</h1>

	renderTourInfoRow = (): React.ReactNode => {
		const { item = {} as Collection } = this.props

		const durationText = this.getTourDurationString()
		const distanceText = this.getDistance()

		return (
			<IonRow className="tour-metadata">
				{item.stop_count ? (
					<IonCol className="data">
						<i className={classnames('icon', getDirMode(), 'fas fa-map-marker-alt')} />
						<IonText className="label">{`${item.stop_count} ${strings.stops}`}</IonText>
					</IonCol>
				) : null}

				{item.tour_type && <IonCol className="data">{this.renderTourTypeIcon()}</IonCol>}

				{durationText && (
					<IonCol className="data">
						<i className={classnames('icon', getDirMode(), 'fas fa-clock')} />
						<IonText className="label">{durationText}</IonText>
					</IonCol>
				)}

				{distanceText && (
					<IonCol className="data">
						<i
							className={classNames(
								'icon',
								'fak',
								item.distance_loop ? 'fa-ic-tour-distance-return' : 'fa-ic-tour-distance-one-way',
							)}
						/>
						<IonText className="label">{distanceText}</IonText>
					</IonCol>
				)}
			</IonRow>
		)
	}

	renderHeading = (): React.ReactNode => {
		const { item = {} as Collection } = this.props
		const { loading } = this.state

		return (
			<div className="tour-heading">
				{loading ? (
					<TextPlaceholder />
				) : (
					<>
						{this.renderTitle(item.title)}
						{this.renderTourInfoRow()}
					</>
				)}
			</div>
		)
	}

	renderAudioPreview = () => {
		const { item = {} as Collection } = this.props

		if (!item.audio_preview) {
			return undefined
		}

		return (
			<SectionMediaAudioComponent
				audioPreview={item.audio_preview}
				container={{ type: 'tour', id: item.id, title: item.name }}
				collectionId={item.id}
			/>
		)
	}

	renderTourDescription = () => {
		const { item = {} as Collection } = this.props
		const { loading } = this.state
		// Why can it be NaN?
		const margin = parseInt(getStyleProperty('--content-margin-horizontal')) || 0

		return (
			<IonRow
				className="description body-text"
				style={{
					paddingTop: 0,
					paddingBottom: 0,
					marginTop: margin,
					marginBottom: margin,
					paddingLeft: margin,
					paddingRight: margin,
				}}
			>
				{loading ? <TextPlaceholder width="60%" /> : <div dangerouslySetInnerHTML={{ __html: item.description }} />}
			</IonRow>
		)
	}

	renderContent = (): React.ReactNode => {
		const { item = {} as Collection, onBackAction, isInsideModal } = this.props
		const { loading } = this.state

		const { cover_image: coverImage } = item

		const imageUrl =
			coverImage?.file &&
			generateImageUrl(coverImage.file, {
				imageSizePreset: ImageSizePreset.Row,
			})
		const imageSrcSet =
			coverImage?.file &&
			generateImageSrcSet(coverImage.file, {
				imageSizePreset: ImageSizePreset.Row,
			})

		return (
			<>
				<Header
					title={strings.tour_details_title}
					onBackButton={onBackAction}
					hideBackButton={isInsideModal}
					showBackButton={Boolean(onBackAction)}
					hideTitle={true}
					isTransparentHeader={true}
					screen={null}
					collection={item}
					collectionItem={null}
					hideFavouriteButton={false}
					itemId={item.id}
					itemType={GetCollectionItemsIndexResponseData.ItemTypeEnum.Collection}
				/>
				{(imageUrl || loading) && (
					<div className="cover-img-wrapper">
						{loading ? (
							<ImagePlaceholder className="cover-img" />
						) : (
							<img src={imageUrl} srcSet={imageSrcSet} className="cover-img" alt={getImageAlt(coverImage)} />
						)}
					</div>
				)}

				<IonGrid className="tour-content">
					{this.renderHeading()}
					<div className="content">
						{this.renderAudioPreview()}
						{this.renderTourDescription()}
					</div>
				</IonGrid>
				{/* Render footer outside of `tour-content` so that */}
				{/* the background span the whole width (require when using app backgroundimage) */}
				{this.renderFooter()}
			</>
		)
	}

	renderFooter = (): React.ReactNode => {
		const { item = {} as Collection, isInsideModal } = this.props
		const { loading } = this.state

		if (loading) return

		const bgColor = getStyleProperty('--background-color')

		const beforeBackgroundImage = `linear-gradient(180deg,
			${fade(bgColor, 0)} 0,
			${fade(bgColor, 0.07407407)} 4.49%,
			${fade(bgColor, 0.25925926)} 16.59%,
			${fade(bgColor, 0.5)} 34.25%,
			${fade(bgColor, 0.74074074)} 55.41%,
			${fade(bgColor, 0.92592593)} 78.01%,
			${bgColor})`

		return (
			<ScrollbarListener element={getPageContainer(this.footerRef?.current)}>
				{scrollbarWidth => (
					<IonFooter className="tour-footer" style={{ paddingInlineEnd: scrollbarWidth }} ref={this.footerRef}>
						{item?.item_count > 0 ? (
							<div className="start-tour-content">
								<div className="start-tour-before" style={{ background: beforeBackgroundImage }} />
								<div className="tour-content">
									<div className="start-tour-buttons">
										{this.renderButtons()}
									</div>
								</div>
							</div>
						) : null}
						{!isInsideModal && <AudioPlayerBarComponent />}
					</IonFooter>
				)}
			</ScrollbarListener>
		)
	}

	renderButtons = () => {
		const { hasLoadedStops, isLoadingStops, item } = this.props
		const { codeLock, hasWebPrice } = this.state

		if (hasLoadedStops) {
			if ((item?.code_lock && codeLock) || hasWebPrice) {
				const price = hasWebPrice ? formatCurrency(item.pricing.web_price.currency, item.pricing.web_price.amount) : ''
				const buyButtonText = strings.formatString(strings.buy_for, { price }) as string
				return (
					<>
						<Button fill="clear" onClick={this.onTourButtonPressed} ariaLabel={strings.enter_code} className="btn">
							{strings.enter_code}
						</Button>
						{hasWebPrice && <Button fill="clear" onClick={this.onBuyButtonPressed} ariaLabel={buyButtonText} className="btn">
							{buyButtonText}
						</Button>}
					</>
				)
			} else {
				return (
					<Button fill="clear" onClick={this.onTourButtonPressed} ariaLabel={strings.start_tour} className="btn start-btn">
						{strings.start_tour}
					</Button>
				)
			}
		} else {
			const buttonText = isLoadingStops ? strings.downloading_tour : strings.download_tour
			return (
				<Button fill="clear" onClick={this.onTourButtonPressed} ariaLabel={buttonText} className="btn">
					{buttonText}
				</Button>
			)
		}
	}

	render() {
		const { error, item = {} as Collection, isInsideModal } = this.props

		const { title, description, cover_image: coverImage } = item

		let imageUrl: string | null = null
		if (coverImage?.file) {
			imageUrl = generateImageUrl(coverImage.file, {
				imageSizePreset: ImageSizePreset.Row,
			})
		}

		if (!item || error?.status === 404) {
			return <Redirect to={get404Url()} />
		}

		return (
			<>
				<Helmet
					title={title}
					meta={[
						{ name: 'description', content: description || title },
						{ property: 'og:type', content: 'website' }, // TODO: check type
						{ property: 'og:title', content: title },
						{ property: 'og:description', content: description || title },
						{ property: 'og:image', content: imageUrl },
						{ property: 'og:url', content: window.location.href },
					]}
				/>

				<Page
					contentProps={{
						className: 'collection-tour',
					}}
					dataItemId={String(item.id)}
					dataItemType="collection"
					dataItemSubtype="tour"
					dataCy="page-collection-tour"
				>
					<ErrorMessageHandler error={error} />
					{!error && item && <>{this.renderContent()}</>}
				</Page>
				{!(!error && item) && !isInsideModal && <AudioPlayerBarComponent />}
				{this.renderLockContentModal()}
			</>
		)
	}
}

const CollectionTourComponent = Container.default(CollectionTour)
export default CollectionTourComponent as any
